import { createContext } from "react";
/**
 * Global storage used during SSR.
 *
 * It can only be accessed syncronously, during a React render.
 */ export var SSRRequestLocalStorage = /*#__PURE__*/ createContext(undefined);
